var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Combobox } from "../../controls/Combobox";
import { Icon } from "../../Icon";
import { BASE_BORDER_WIDTH, BASE_FONT, SPACING_XL } from "../../helpers";
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../../StackView";
import { INDENT } from "../../View";
import { LanguageIcon } from "../../icons";
import { ArrowDownIcon } from "../../ArrowIcon";
export function getIndexItem(items, value, valueGetter, compareValue) {
    var result = -1;
    items.some(function (item, idx) {
        if (compareValue(valueGetter(item), value)) {
            result = idx;
            return true;
        }
        return false;
    });
    return result;
}
var WrapperArrow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    width: calc(", " - 2 * ", ");\n    height: 100%;\n\n    > svg {\n        fill: ", ";\n    }\n"], ["\n    display: flex;\n    width: calc(", " - 2 * ", ");\n    height: 100%;\n\n    > svg {\n        fill: ", ";\n    }\n"])), SPACING_XL, BASE_BORDER_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.colorLoginTitle;
});
var Button = styled(StackView)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: inline-flex;\n    height: ", ";\n    font: ", ";\n    cursor: pointer;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"], ["\n    display: inline-flex;\n    height: ", ";\n    font: ", ";\n    cursor: pointer;\n\n    ",
    "\n\n    ",
    "\n\n    ",
    "\n\n    ",
    "\n"])), SPACING_XL, BASE_FONT, function (_a) {
    var theme = _a.theme;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        color: ", ";\n\n        ", " {\n            color: ", ";\n        }\n    "], ["\n        color: ", ";\n\n        ", " {\n            color: ", ";\n        }\n    "])), theme.colorLoginTitle, Icon.selector, theme.colorLoginTitle);
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return !disabled && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            &:hover {\n                background-color: ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n            }\n        "], ["\n            &:hover {\n                background-color: ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n            }\n        "])), theme.colorLoginSSOButtonHover, theme.colorLoginSSOButtonActive);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            cursor: default;\n            opacity: 0.3;\n\n            &:hover,\n            &:active {\n                background-color: transparent;\n            }\n        "], ["\n            cursor: default;\n            opacity: 0.3;\n\n            &:hover,\n            &:active {\n                background-color: transparent;\n            }\n        "])));
}, function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            &,\n            &:hover,\n            &:active {\n                background-color: ", ";\n            }\n        "], ["\n            &,\n            &:hover,\n            &:active {\n                background-color: ", ";\n            }\n        "])), theme.colorLoginSSOButtonActive);
});
function createControl(_a) {
    var _b = (_a === void 0 ? {} : _a).formatText, formatText = _b === void 0 ? function (_a) {
        var option = _a.option;
        return (option === null || option === void 0 ? void 0 : option.title) || '';
    } : _b;
    return function linkButtonControlRenderer(_a) {
        var className = _a.className, control = _a.control, error = _a.error, placeholder = _a.placeholder, disabled = _a.disabled, size = _a.size, opened = _a.opened, text = _a.text, option = _a.option, value = _a.value, testId = _a.testId, active = _a.active, actions = _a.actions, focused = _a.focused, onClear = _a.onClear, searchTerm = _a.searchTerm, onSearchTermChange = _a.onSearchTermChange, style = _a.style, rest = __rest(_a, ["className", "control", "error", "placeholder", "disabled", "size", "opened", "text", "option", "value", "testId", "active", "actions", "focused", "onClear", "searchTerm", "onSearchTermChange", "style"]);
        return (React.createElement(Button, __assign({}, rest, { className: className, "data-selector-id": testId, disabled: disabled, isActive: opened, spaceLeft: INDENT.s, align: STACK_ALIGN.center, direction: STACK_DIRECTION.row, gap: STACK_GAP.s, onBlur: control.onBlur, onFocus: control.onFocus, onClick: control.onClick, onMouseDown: control.onMouseDown, onMouseUp: control.onMouseUp, onMouseEnter: control.onMouseEnter, onMouseLeave: control.onMouseLeave, onKeyDown: control.onKeyDown, onKeyUp: control.onKeyUp, onKeyPress: control.onKeyPress, ref: control.ref, style: control.style }),
            React.createElement(Icon, { src: React.createElement(LanguageIcon, null) }),
            React.createElement("div", null, formatText({ text: text, option: option, value: value })),
            React.createElement(WrapperArrow, null,
                React.createElement(ArrowDownIcon, null))));
    };
}
export var LoginLanguageSelector = function (_a) {
    var value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, items = _a.items, onChange = _a.onChange, rest = __rest(_a, ["value", "disabled", "items", "onChange"]);
    return (React.createElement(Combobox, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'login-language-selector', disabled: disabled, value: value, data: items, textGetter: function (_a) {
            var title = _a.title;
            return title;
        }, valueGetter: function (_a) {
            var value = _a.value;
            return value;
        }, onChange: onChange, controlRenderer: createControl() })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=LoginLanguageSelector.js.map